import axiosPrivateMl from "../axiosPrivateMl"

const logoutUser = async (userId) => {
  try {
    const response = await axiosPrivateMl.post("/logout", {
      user_id: userId,
    })

    return response.data
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error("Error logging out user:", error.response.data)
      throw error.response.data
    } else if (error.request) {
      // The request was made but no response was received
      console.error("No response received:", error.request)
      throw new Error("No response from server")
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("Error:", error.message)
      throw error
    }
  }
}

export default logoutUser
